var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.filteredEntries.length)?_c('div',{staticClass:"grid-display"},[_c('div',{staticClass:"grid-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"flex-box"},_vm._l((_vm.filteredEntries),function(character,index){return _c('div',{key:index,staticClass:"flex-entry"},[_c('Tile',{attrs:{"character":character}})],1)}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }